/**
 * True if [aStart, aEnd] overlaps [bStart, bEnd]. End-inclusive.
 * Open-ended (null end) treated as +Infinity.
 */
export const rangesOverlap = (
  aStart: string,
  aEnd: string | null,
  bStart: string,
  bEnd: string | null,
): boolean => {
  const aS = new Date(aStart).getTime();
  const aE = aEnd ? new Date(aEnd).getTime() : Number.POSITIVE_INFINITY;
  const bS = new Date(bStart).getTime();
  const bE = bEnd ? new Date(bEnd).getTime() : Number.POSITIVE_INFINITY;
  return aS <= bE && bS <= aE;
};
